import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import React from "react";
import { useEnvironment } from "../../hooks/use-environment";
import { ModelCanvasProps } from "./shared";

const LAZY_ModelCanvas = React.lazy(() =>
  import("./three-js/3DViewerComponent").then(m => ({ default: m.ModelCanvas })),
);

export const CanvasClientOnly: ReactTFC<ModelCanvasProps> = props => {
  const env = useEnvironment();

  return env === "browser" ? (
    <React.Suspense fallback={null}>
      <LAZY_ModelCanvas {...props} />
    </React.Suspense>
  ) : null;
};
